import { Col, Row } from 'antd';
import { AxiosError } from 'axios';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';
import StatementWrapper from 'components/molecules/StatementWrapper';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { IZadostResp, nzZadostApi } from 'services/nezarazenyUcet/nuZapis';
import BIPOSK from './stavPages/BIPOSK';
import IDEN from './stavPages/IDEN';
import OBJED from './stavPages/OBJED';
import PLZAPL from './stavPages/PLZAPL';
import SOUHL from './stavPages/SOUHL';
import UCDAL from './stavPages/UCDAL';
import ZapisPrehled from './ZapisPrehled';

interface IVypisUvod {}

const VypisZadost: React.FC<IVypisUvod> = () => {
    const history = useHistory();
    const [loading, setLoading] = useState<boolean>(false);
    const [zadostData, setZadostData] = useState<IZadostResp>();
    const [errStatus, setErrStatus] = useState<number>();
    const { token } = useParams<{ token: string }>(); // token sebran z urlky

    const routeChange = () => {
        let path = zadostData?.zadostid
            ? '/nezarazeny-ucet-zapis/idzadost/' + zadostData.zadostid
            : '/nezarazeny-ucet-zapis/idzadost/';
        history.push(path);
    };
    console.log(token, window.location.href, history);
    useEffect(() => {
        setTimeout(() => window.parent.scrollTo(0, 0), 0);
    }, [token, history, zadostData]);

    useEffect(() => {
        if (token) {
            setLoading(true);
            nzZadostApi(token)
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .then((resp: any) => {
                    setZadostData(resp);
                    setLoading(false);
                    !token && routeChange();
                })
                .catch((err: AxiosError) => {
                    setErrStatus(err.response?.status);
                    setLoading(false);
                });
        }
        // : history.push(routePathEnum.VYPIS_BANKID_NOID); // Pokud nebude na konci url token dojde k redirectu uživatele zpět na stránku s loginem do bankid
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <StatementWrapper pageTitle="">
            <LoadingWrapper loading={loading}>
                {errStatus ? (
                    <Col span={24}>
                        <Row>
                            {errStatus === 400 ? (
                                <Title text="RESPONSE_ERROR_400" level={3} />
                            ) : errStatus === 401 ? (
                                <Title text="RESPONSE_ERROR_401" level={3} />
                            ) : errStatus === 404 ? (
                                <Title text="RESPONSE_ERROR_404" level={3} />
                            ) : errStatus === 500 ? (
                                <Title text="RESPONSE_ERROR_500" level={3} />
                            ) : errStatus ? (
                                <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                            ) : null}
                        </Row>
                    </Col>
                ) : zadostData?.email && zadostData?.telefon ? (
                    <>
                        {zadostData.stav ? (
                            <div>
                                {zadostData.stav === 'SOUHL' ? (
                                    <SOUHL zadostData={zadostData} setZadostData={setZadostData} /> // Stav OBJED - uživatel potvrdil a odeslal objednávku, byl mu odeslán email o potvrzení nyní se bude uživateli zobrazovat stránka s tlačítkem na platbu a shrnutím
                                ) : zadostData.stav === 'OBJED' || zadostData.stav === 'PLZRUS' ? (
                                    <OBJED zadostData={zadostData} /> // Stav OBJED - uživatel potvrdil a odeslal objednávku, byl mu odeslán email o potvrzení nyní se bude uživateli zobrazovat stránka s tlačítkem na platbu a shrnutím
                                ) : zadostData.stav === 'BIPOSK' ? (
                                    <BIPOSK zadostData={zadostData} setZadostData={setZadostData} />
                                ) : zadostData.stav === 'UCDAL' ? (
                                    <UCDAL zadostData={zadostData} />
                                ) : zadostData.stav === 'PLZAPL' ? (
                                    <PLZAPL zadostData={zadostData} /> // Stav PLZAPL - uživatel zaplatil, nyní potřebujeme aby se přihlásil přes bankid ze kterého dostaneme rodné číslo
                                ) : zadostData.stav === 'CEKA' ||
                                  zadostData.stav === 'ZPRAC' ||
                                  zadostData.stav === 'BINEPO' ? (
                                    // Stav CEKA - Zobrazí se page s přehledem s informací o tom, že se výpis pro uživatele zpracovává
                                    // Stav DUPL - Duplicitní údaje, uživateli se zobrazí hláška o tom, že bude kontaktován CDCP. Výpis z nezařazeného účtu nemůže být automaticky přidělen bez jeho dalšího upřesnění
                                    // Stav ZPRAC - Zobrazí se page s přehledem a hláškou o tom, že je výpis zpracován. Výpis je možné do určitého data stáhnout přes tlačítko na stránce.
                                    // Stav VYPR - Zobrazí se page s přehledem a hláškou o tom, že platnost výpisu vypršela. Uživatel musí zaplatit za nový výpis pokud ho potřebuje.
                                    // Stav BINEPO - Žadatel se přihlásil přes Bank iD ale neposkytl povinné údaje.
                                    <ZapisPrehled stav={zadostData.stav} zadostData={zadostData} />
                                ) : (
                                    <TranslateText>SLUZBA_NEDOSTUPNA</TranslateText> // K vypsani teto zpravy dojde pokud stav nebude aplikaci nijak znam. Opet by k vypsani nemelo dojit BUT
                                    // vzdycky se muze pridat nejakej dalsi stav ze kterim se nepocitalo.
                                )}
                            </div>
                        ) : (
                            <TranslateText>NEZNAMY_STAV</TranslateText> // K vypsani teto zpravy dojde pokud stav neexistuje. Nemelo by dojit BUT vzdycky muze nastat situace kde se neco z*sere, BE prestane vracet stav a aplikace by zbytecne padala :D
                        )}
                    </>
                ) : (
                    <IDEN zadostData={zadostData} setZadostData={setZadostData} /> // Stav IDEN - uživatel je přesměrován z bank id, na stránce se zobrazí jméno, příjmení a e-mail z Bank ID s podmínkama o získání výpisu. Po odsouhlasení jde uživatel zaplatit.
                )}
            </LoadingWrapper>
        </StatementWrapper>
    );
};

export default VypisZadost;
